import React, { useEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getRoleId } from './operations';
import pushNotificationsOptions from './pushNotificationsOptions';
import { SubHeader, Footer } from '../../components';
import useIsMobileScreen from '../../hooks/useCheckIsMobile';
import './styles.scoped.css';

const PushNotifications = () => {
  const navigate = useNavigate();
  const { menuData } = pushNotificationsOptions;
  const user = useSelector(state => state.admin?.user);
  const [roleId, setRoleId] = useState();
  const isMobile = useIsMobileScreen;

  const getApplicationRoleUserAppAccessId = async () => {
    const response = await getRoleId(user.id);
    response?.forEach(item => {
      if (item?.appId?.name === 'Push Notifications') {
        setRoleId(item?.applicationRoleUserAppAccessId);
      }
    });
  };

  useEffect(() => {
    if (user.id) {
      getApplicationRoleUserAppAccessId(user.id);
    }
  }, [user]);

  return (
    <>
      <SubHeader
        text="Push Notifications"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
      />

      <div className="wrap">
        <div className="row">
          <div className="header">Choose your Notification</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 80 }}>
          <span className="row">
            {menuData?.map(
              i =>
                i.roleId === roleId &&
                i.items.slice(0, -1)?.map(f => (
                  <div
                    key={f.title}
                    style={{ minWidth: isMobile ? '320px' : '390px' }}
                    className="button"
                    onClick={() => navigate(f.to)}>
                    {f.title}
                  </div>
                )),
            )}
          </span>
          <span className="row">
            {menuData?.map(
              i =>
                i.roleId === roleId && (
                  <div
                    key={i.items[i.items.length - 1].title}
                    style={{ minWidth: isMobile ? '320px' : '390px' }}
                    className="button"
                    onClick={() => navigate(i.items[i.items.length - 1].to)}>
                    {i.items[i.items.length - 1].title}
                  </div>
                ),
            )}
          </span>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PushNotifications;
